import { EditInsurerDetailsForm } from '.';
import { type InsurerDetailsDataFragment } from '../../../../api/fragments/InsurerDetailsData';

export type EditInsurerFormProps = {
    updated: string;
    insurer: InsurerDetailsDataFragment;
    offset: string;
    disabled?: boolean;
};

const EditInsurerForm = ({ updated, insurer, offset, disabled = false }: EditInsurerFormProps) => (
    <EditInsurerDetailsForm disabled={disabled} extra={null} insurer={insurer} offset={offset} updated={updated} />
);

export default EditInsurerForm;
